import React from "react";

export function NavBarLogo() {
  return <img style={{ width: "78px", height: "34px" }} src="/img/logo/SwivlStudioWritten.png" alt="swivl" />;
}
